import React from 'react';
import { validatePassword, getPasswordStrength } from '../utils/passwordPolicy';
import './PasswordStrengthIndicator.css';

const PasswordStrengthIndicator = ({ 
  password, 
  email = '', 
  username = '', 
  showRequirements = true,
  showSuggestions = true 
}) => {
  if (!password) {
    return null;
  }

  const validation = validatePassword(password, email, username);
  const strength = getPasswordStrength(validation.score);

  return (
    <div className="password-strength-indicator">
      {/* Strength Bar */}
      <div className="strength-bar-container">
        <div className="strength-bar">
          <div 
            className="strength-fill"
            style={{ 
              width: `${strength.percentage}%`,
              backgroundColor: strength.color
            }}
          />
        </div>
        <span className="strength-label" style={{ color: strength.color }}>
          {strength.level}
        </span>
      </div>

      {/* Requirements Checklist */}
      {showRequirements && (
        <div className="requirements-checklist">
          <h4>Password Requirements:</h4>
          <ul className="requirements-list">
            <li className={validation.requirements.length.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.length.met ? '✓' : '✗'}
              </span>
              {validation.requirements.length.message}
            </li>
            
            <li className={validation.requirements.uppercase.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.uppercase.met ? '✓' : '✗'}
              </span>
              {validation.requirements.uppercase.message}
            </li>
            
            <li className={validation.requirements.lowercase.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.lowercase.met ? '✓' : '✗'}
              </span>
              {validation.requirements.lowercase.message}
            </li>
            
            <li className={validation.requirements.numbers.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.numbers.met ? '✓' : '✗'}
              </span>
              {validation.requirements.numbers.message}
            </li>
            
            <li className={validation.requirements.specialChars.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.specialChars.met ? '✓' : '✗'}
              </span>
              {validation.requirements.specialChars.message}
            </li>
            
            <li className={validation.requirements.forbiddenPatterns.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.forbiddenPatterns.met ? '✓' : '✗'}
              </span>
              {validation.requirements.forbiddenPatterns.message}
            </li>
            
            <li className={validation.requirements.commonPasswords.met ? 'met' : 'not-met'}>
              <span className="requirement-icon">
                {validation.requirements.commonPasswords.met ? '✓' : '✗'}
              </span>
              {validation.requirements.commonPasswords.message}
            </li>
            
            {email && (
              <li className={validation.requirements.emailPattern.met ? 'met' : 'not-met'}>
                <span className="requirement-icon">
                  {validation.requirements.emailPattern.met ? '✓' : '✗'}
                </span>
                {validation.requirements.emailPattern.message}
              </li>
            )}
            
            {username && (
              <li className={validation.requirements.usernamePattern.met ? 'met' : 'not-met'}>
                <span className="requirement-icon">
                  {validation.requirements.usernamePattern.met ? '✓' : '✗'}
                </span>
                {validation.requirements.usernamePattern.message}
              </li>
            )}
          </ul>
        </div>
      )}

      {/* Suggestions */}
      {showSuggestions && validation.suggestions.length > 0 && (
        <div className="password-suggestions">
          <h4>Suggestions:</h4>
          <ul className="suggestions-list">
            {validation.suggestions.map((suggestion, index) => (
              <li key={index} className="suggestion-item">
                💡 {suggestion}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PasswordStrengthIndicator;
